import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useAperzaUserContext } from './AperzaUserContext';
import AppConfig from '../utils/AppConfig';
import { CatalogCategoryButton } from './CatalogCategoryButton';
export default function ServiceMenu() {
    var serviceType = useAperzaUserContext().serviceType;
    if (serviceType === AppConfig.APERZA_CATALOG) {
        return _jsx(CatalogCategoryButton, {});
    }
    return _jsx(_Fragment, {});
}
